// NOTE: hooks
import useLink from './useLink'
import { FaLinkSlash as LinkSlash } from "react-icons/fa6"
// NOTE: components
import EmptyPrompt from '../ui/EmptyPrompt'

interface LinkCardProps {
    link: string
}

const LinkCard = ({ link }: LinkCardProps) => {
    const { isLoadingLink, isErrorLink, errorLink, linkData } = useLink(link)

    if (isLoadingLink) return <div className="my-4 rounded-2xl h-[200px] skeleton" />

    if (isErrorLink) {
        console.error("We couldn't get your link", errorLink?.message)
    }

    return (
        <>
            {!isErrorLink && linkData && (
                <a href={linkData?.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 border border-gray-200 rounded-2xl p-3 my-4 no-underline hover:bg-slate-50">
                    <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-3 mb-3">
                            {linkData?.favicon && <img className="size-8 !m-0 object-contain !rounded-sm" src={linkData?.favicon} alt={linkData?.title} />}
                            {linkData?.title &&
                                <span
                                    className="font-bold text-[#0C66E4] hover:underline truncate">
                                    {linkData?.title}
                                </span>
                            }
                            {!linkData?.title && linkData?.url && (
                                <span
                                    className="text-sm font-bold text-[#0C66E4] hover:underline truncate">
                                    {linkData.domain}
                                </span>
                            )}
                        </div>
                        <p className="text-sm !m-0 break-words line-clamp-3">{linkData?.description}</p>
                        <div className="flex mt-3 items-center gap-3">
                            {linkData?.favicon && <img className="size-5 !m-0 object-contain !rounded-sm" src={linkData?.favicon} alt={linkData?.favicon} />}
                            {linkData?.url && (
                                <p className="text-sm !m-0 text-ellipsis overflow-hidden text-nowrap">
                                    {linkData.domain}
                                </p>
                            )}
                        </div>
                    </div>
                    {linkData?.image && <img className="h-auto w-20 sm:w-28 !m-0 object-contain rounded-md" src={linkData?.image} alt={linkData?.title} />}
                    {!linkData?.image && <img className="size-24 !m-0 object-contain" src={linkData?.favicon} alt={linkData?.title} />}
                </a>
            )}
            {(isErrorLink || !linkData) && (
                <EmptyPrompt
                    illustration={<LinkSlash className="h-auto w-full" />}
                    title="We couldn't display your link"
                    description="The link may be broken, or might no longer exist."
                />
            )}
        </>
    )
}

export default LinkCard